import React from "react";
import "./AiShadowControlMenu.css";

import {
  softShadowImg,
  hardShadowImg,
  floatingShadowImg,
  noneShadowImg,
  softShadowSelectedImg,
  hardShadowSelectedImg,
  floatingShadowSelectedImg,
  noneShadowSelectedImg,
} from "../../../../icons/assets";

const AiShadowControlMenu = ({
  onShadowSelect = () => {},
  onApplyCloudinaryShadow,
  shadowBusy = false,
}) => {
  const [selectedShadow, setSelectedShadow] = React.useState("none");

  const shadowOptions = [
    {
      id: "soft",
      name: "Soft",
      description: "Soft shadow effect",
      image: softShadowImg,
      imageSelected: softShadowSelectedImg,
    },
    {
      id: "hard",
      name: "Hard",
      description: "Hard shadow effect",
      image: hardShadowImg,
      imageSelected: hardShadowSelectedImg,
    },
    {
      id: "floating",
      name: "Floating",
      description: "Floating shadow effect",
      image: floatingShadowImg,
      imageSelected: floatingShadowSelectedImg,
    },
    {
      id: "none",
      name: "None",
      description: "No shadow",
      image: noneShadowImg,
      imageSelected: noneShadowSelectedImg,
    },
  ];

  const handleShadowSelect = (shadowId) => {
    setSelectedShadow(shadowId);
    onShadowSelect(shadowId);
  };

  return (
    <div className="ai-shadow-control-menu-container">
      <div className="ai-shadow-options-grid">
        {shadowOptions.map((option) => (
          <div
            key={option.id}
            className={`ai-shadow-option-card ${
              selectedShadow === option.id ? "selected" : ""
            }`}
            onClick={() => handleShadowSelect(option.id)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                handleShadowSelect(option.id);
              }
            }}
          >
            <div className="ai-shadow-option-preview">
              <img
                src={
                  selectedShadow === option.id
                    ? option.imageSelected
                    : option.image
                }
                alt={`${option.name} shadow preview`}
                className="ai-shadow-option-preview-image"
              />
            </div>
            <p className="ai-shadow-option-name">{option.name}</p>
          </div>
        ))}
      </div>

      <button
        className="ai-shadow-apply-btn"
        disabled={
          shadowBusy ||
          selectedShadow === "none" ||
          typeof onApplyCloudinaryShadow !== "function"
        }
        onClick={() => {
          if (typeof onApplyCloudinaryShadow === "function") {
            onApplyCloudinaryShadow(selectedShadow);
          }
        }}
      >
        {shadowBusy
          ? "Applying…"
          : selectedShadow === "none"
            ? "Select a shadow"
            : "Apply shadow (API)"}
      </button>
    </div>
  );
};

export default AiShadowControlMenu;
